(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    customElements.define(
      'hero-slider',
      class HeroSlider extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.tabs = [...this.querySelectorAll('[data-tab]')];
          this.index = 0;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.go(i)));
          this.addEventListener('keydown', (e) => {
            if (!e.target.matches('[data-tab]')) return;
            const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
            if (!step) return;
            e.preventDefault();
            this.go(this.index + step, true);
          });
          // Horizontal swipe on touch screens; vertical drags keep scrolling the page.
          let x0 = null, y0 = 0;
          this.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') { x0 = e.clientX; y0 = e.clientY; } }, { passive: true });
          this.addEventListener('pointerup', (e) => {
            if (x0 === null) return;
            const dx = e.clientX - x0, dy = e.clientY - y0;
            x0 = null;
            if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
          }, { passive: true });
          this.enter(this.slides[0], 1);

          // Autoplay: the active tab's bar fills over 6 s in CSS and its animationend moves on. Pointer over the copy or
          // tabs, keyboard focus and an off-screen hero pause it; reduced-motion users get no autoplay.
          if (this.reduced || this.slides.length < 2) return;
          this.dataset.autoplay = '';
          const holds = new Set();
          const hold = (key, on) => {
            holds[on ? 'add' : 'delete'](key);
            this.classList.toggle('is-paused', holds.size > 0);
          };
          this.addEventListener('pointerover', (e) => {
            if (e.pointerType === 'mouse') hold('hover', !!e.target.closest('.dp-hstage__copy, .dp-hstage__tabs'));
          });
          this.addEventListener('mouseleave', () => hold('hover', false));
          this.addEventListener('focusin', (e) => hold('focus', e.target.matches(':focus-visible')));
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) hold('focus', false); });
          new IntersectionObserver(([e]) => hold('view', !e.isIntersecting)).observe(this);
          this.addEventListener('animationend', (e) => {
            if (e.animationName === 'dp-hstage-progress') this.go(this.index + 1);
          });
        }

        go(i, focus) {
          const n = this.slides.length;
          const next = (i + n) % n;
          if (next === this.index) return;
          const dir = next > this.index ? 1 : -1;
          const from = this.slides[this.index];
          const to = this.slides[next];
          this.index = next;
          from.classList.remove('is-active');
          from.inert = true;
          to.classList.add('is-active');
          to.inert = false;
          this.tabs.forEach((t, j) => {
            t.setAttribute('aria-selected', String(j === next));
            t.tabIndex = j === next ? 0 : -1;
          });
          if (focus) this.tabs[next].focus();
          // Keep the active tab visible in the scrolling tab row without moving the page.
          const tab = this.tabs[next];
          tab.parentElement.scrollTo({ left: tab.offsetLeft - 16, behavior: this.reduced ? 'auto' : 'smooth' });
          this.enter(to, dir);
        }

        // One sequence per change: the photo slides in from the travel side, then the copy rises line by line.
        enter(slide, dir) {
          if (this.reduced || !slide.animate) return;
          const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
          slide.querySelector('[data-anim="media"]').animate(
            [{ opacity: 0, transform: `translateX(${dir * 48}px) scale(0.98)` }, { opacity: 1, transform: 'none' }],
            { duration: 700, easing: ease, fill: 'backwards' }
          );
          slide.querySelectorAll('[data-anim]:not([data-anim="media"])').forEach((el, k) =>
            el.animate(
              [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'none' }],
              { duration: 520, delay: 120 + k * 80, easing: ease, fill: 'backwards' }
            )
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-media')) {
    customElements.define(
      'hero-media',
      class HeroMedia extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('[data-hero-toggle]');
          if (!this.video || !this.button) return;
          const mobile = window.matchMedia('(max-width: 767px)').matches;
          this.url = (mobile && this.dataset.mobileSrc) || this.dataset.src;
          this.button.addEventListener('click', () => this.toggle());
          this.video.addEventListener('play', () => this.sync());
          this.video.addEventListener('pause', () => this.sync());
          // The hero image is the LCP element: start the video only after the page has loaded.
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            if (document.readyState === 'complete') this.start();
            else window.addEventListener('load', () => this.video.getAttribute('src') || this.start(), { once: true });
          }
          this.sync();
        }

        start() {
          if (!this.video.getAttribute('src')) this.video.src = this.url;
          const played = this.video.play();
          if (played) played.catch(() => this.sync());
        }

        toggle() {
          if (this.video.paused) this.start();
          else this.video.pause();
        }

        sync() {
          const paused = this.video.paused;
          const label = paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause;
          this.button.setAttribute('aria-label', label);
          this.button.querySelector('[data-hero-icon="play"]').hidden = !paused;
          this.button.querySelector('[data-hero-icon="pause"]').hidden = paused;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-seo-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seo-text')) {
    customElements.define(
      'seo-text',
      class SeoText extends HTMLElement {
        connectedCallback() {
          const body = this.querySelector('[data-seo-body]');
          const button = this.querySelector('.dp-hseo__toggle');
          if (!body || !button) return;
          button.hidden = false;
          button.addEventListener('click', () => {
            const open = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(open));
            body.toggleAttribute('data-expanded', open);
            button.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-workshop-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('workshop-video')) {
    let playingClip = null;
    customElements.define(
      'workshop-video',
      class WorkshopVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('.dp-hclip__play');
          if (!this.video || !this.button) return;
          this.button.addEventListener('click', () => (this.video.paused ? this.play() : this.video.pause()));
          this.video.addEventListener('play', () => this.sync());
          this.video.addEventListener('pause', () => this.sync());
          const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
          const still = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.addEventListener('mouseenter', () => {
            if (hover.matches && !still.matches) this.play();
          });
          this.addEventListener('mouseleave', () => {
            if (hover.matches && !still.matches) this.video.pause();
          });
        }

        play() {
          if (playingClip && playingClip !== this) playingClip.video.pause();
          playingClip = this;
          const started = this.video.play();
          if (started) started.catch(() => {});
        }

        sync() {
          const paused = this.video.paused;
          this.button.setAttribute('aria-pressed', String(!paused));
          this.button.setAttribute('aria-label', paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
          this.button.querySelector('[data-clip-icon="play"]').hidden = !paused;
          this.button.querySelector('[data-clip-icon="pause"]').hidden = paused;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-e404-search]');
    const path = document.querySelector('[data-e404-path]');
    if (!root || !path) return;
    const bent = path.dataset.bent;
    const flat = path.dataset.flat;
    const supportsD = CSS.supports('d', 'path("M0 0")');
    let hover = false;
    let focus = false;
    const sync = () => {
      const straight = hover || focus;
      if (supportsD) path.style.d = 'path("' + (straight ? flat : bent) + '")';
      else path.setAttribute('d', straight ? flat : bent);
    };
    root.addEventListener('mouseenter', () => { hover = true; sync(); });
    root.addEventListener('mouseleave', () => { hover = false; sync(); });
    root.addEventListener('focusin', () => { focus = true; sync(); });
    root.addEventListener('focusout', () => { focus = false; sync(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-manufacturing"]) return;
  try {
    
  if (!customElements.get('mfg-video')) {
    customElements.define(
      'mfg-video',
      class MfgVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('.dp-mfg__play');
          if (!this.video || !this.button) return;
          // A pause by the visitor wins over scrolling back into view.
          this.held = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.button.addEventListener('click', () => {
            this.held = !this.video.paused;
            this.held ? this.video.pause() : this.play();
          });
          this.video.addEventListener('play', () => this.sync());
          this.video.addEventListener('pause', () => this.sync());
          new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !this.held) this.play();
            else if (!entry.isIntersecting) this.video.pause();
          }, { threshold: 0.35 }).observe(this);
        }

        play() {
          const started = this.video.play();
          if (started) started.catch(() => {});
        }

        sync() {
          const paused = this.video.paused;
          this.button.setAttribute('aria-pressed', String(!paused));
          this.button.setAttribute('aria-label', paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
          this.button.querySelector('[data-clip-icon="play"]').hidden = !paused;
          this.button.querySelector('[data-clip-icon="pause"]').hidden = paused;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
